import React, {Component} from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { config } from '../../constants/domainConfig';
import { FormattedMessage } from 'react-intl';
import BottomLangDropDown from '../BottomLangDropDown/BottomLangDropDown';
import { isMobio360Plus } from '../../constants/multiDomains';
import { showCuCa } from '../../constants/showCuCa';

class BottomMobileMenu extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.toggleLinkActive();
    }

    componentDidUpdate() {
        this.toggleLinkActive();
    }

    toggleLinkActive() {
        let bottomMenuLink = document.querySelectorAll(".bottom-menu-link");
        bottomMenuLink.forEach(function(link) {
            if(link.href.indexOf(window.location.hash) !== -1) {
                link.classList.add("active");
            } else {
                link.classList.remove("active");
            }
        });
    }
    render() {
        let showBottomMenu = this.props.showBottomMenu;
        const menuTexts = {
            home: {
                en: "Home",
                pt: "Início",
                ar: "الرئيسيه",
                ee: "Kodu",
                fr: "Accueil",
                de: "Heim",
                be: "Huis",
                it: "Casa",
                el: "Αρχική",
                id: "Rumah",
                th: "หน้าหลัก"
            },
            image: {
                en: "Image",
                pt: "Imagem",
                ar: " صورة",
                ee: "Pilt",
                fr: "Image",
                de: "Bild",
                be: "Afbeelding",
                it: "Panoramica",
                el: "Εικόνα",
                id: "Gambar",
                th: "รูปภาพ"
            },
            search: {
                en: "Search",
                pt: "Procurar",
                ar: "بحث",
                ee: "Otsing",
                fr: "Chercher",
                de: "Suche",
                be: "Zoeken",
                it: "Cerca",
                el: "Αναζήτηση",
                id: "Mencari",
                th: "ค้นหา"
            },
            history: {
                en: "History",
                pt: "Histórico",
                ar: "يساعد", // (Note: This translates to "help", not "history" in Arabic)
                ee: "Ajalugu",
                fr: "Histoire",
                de: "Geschichte",
                be: "Geschiedenis",
                it: "Cronologia",
                el: "Ιστορικό",
                id: "Sejarah",
                th: "ประวัติ"
            },
            myAccount: {
                en: "My Account",
                pt: "Gestão de conta",
                ar: "حسابي",
                ee: "Minu konto",
                fr: "Mon compte",
                de: "Mein Konto",
                be: "Mijn rekening",
                it: "Il mio account",
                el: "Ο Λογαριασμός Μου",
                id: "Akun saya",
                th: "บัญชีของฉัน"
            },
            help: {
                en: "Contact",
                ar: "تواصل معنا",
                th: "ติดต่อเรา"
            }
            // ContactUs: {
            //     en: "Contact Us",
            //     pt: "Contact Us",
            //     ar: "Contact Us",
            //     ee:"Võta meiega ühendust"
            // }
        }        
        const homeIcon = '<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24"><linearGradient id="MyGradient5"><stop offset="0%"  stop-color="#e08058"/><stop offset="100%" stop-color="#ad1e3c"/></linearGradient><path fill="#695094" d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"/></svg>';
        const homeText = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink= "http://www.w3.org/1999/xlink" viewBox="0 0 40 18" width="40"><defs><linearGradient id="MyGradient1"><stop offset="0%"  stop-color="#e08058"/><stop offset="100%" stop-color="#ad1e3c"/></linearGradient></defs><text dx="-1 -1 -1 -1 -1" fill="#695094" text-anchor="middle" alignment-baseline="middle" x="50%" y="50%">${menuTexts.home[config.lang] || menuTexts.home.en}</text></svg>`;
        const image360Text = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink= "http://www.w3.org/1999/xlink" viewBox="0 0 40 18" width="40"><defs><linearGradient id="MyGradient1"><stop offset="0%"  stop-color="#e08058"/><stop offset="100%" stop-color="#ad1e3c"/></linearGradient></defs><text dx="-1 -1 -1 -1 -1" fill="#695094" text-anchor="middle" alignment-baseline="middle" x="50%" y="50%">${menuTexts.image[config.lang] || menuTexts.image.en}</text></svg>`;
        const helpText = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink= "http://www.w3.org/1999/xlink" viewBox="0 0 40 18" width="40"><defs><linearGradient id="MyGradient1"><stop offset="0%"  stop-color="#e08058"/><stop offset="100%" stop-color="#ad1e3c"/></linearGradient></defs><text dx="-1 -1 -1 -1 -1" fill="#695094" text-anchor="middle" alignment-baseline="middle" x="50%" y="50%">${menuTexts.help[config.lang] || menuTexts.help.en}</text></svg>`;
        const searchIcon = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-search"><linearGradient id="MyGradient6"><stop offset="0%"  stop-color="#e08058"/><stop offset="100%" stop-color="#ad1e3c"/></linearGradient><linearGradient id="MyGradient6a"><stop offset="0%" stop-color="#ad1e3c"/><stop offset="100%" stop-color="#ad1e3c"/></linearGradient><circle stroke="#695094" cx="11" cy="11" r="8"></circle><line stroke="#695094" x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>';
        const searchText = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink= "http://www.w3.org/1999/xlink" viewBox="0 0 44 18" width="44"><defs><linearGradient id="MyGradient2"><stop offset="0%"  stop-color="#e08058"/><stop offset="100%" stop-color="#ad1e3c"/></linearGradient></defs><text dx="-1 -1 -1 -1 -1" fill="#695094" text-anchor="middle" alignment-baseline="middle" x="50%" y="50%">${menuTexts.search[config.lang] || menuTexts.search.en}</text></svg>`;
        const historyIcon = '<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24"><linearGradient id="MyGradient7"><stop offset="0%"  stop-color="#e08058"/><stop offset="100%" stop-color="#ad1e3c"/></linearGradient><path fill="#695094" d="M13 3c-4.97 0-9 4.03-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42C8.27 19.99 10.51 21 13 21c4.97 0 9-4.03 9-9s-4.03-9-9-9zm-1 5v5l4.28 2.54.72-1.21-3.5-2.08V8H12z"/></svg>';
        const historyText = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink= "http://www.w3.org/1999/xlink" viewBox="0 0 44 18" width="44"><defs><linearGradient id="MyGradient3"><stop offset="0%"  stop-color="#e08058"/><stop offset="100%" stop-color="#ad1e3c"/></linearGradient></defs><text dx="-1 -1 -1 -1 -1" fill="#695094" text-anchor="middle" alignment-baseline="middle" x="50%" y="50%">${menuTexts.history[config.lang] || menuTexts.history.en}</text></svg>`;
        const accountIcon = '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 28 28"><linearGradient id="MyGradient8"><stop offset="0%"  stop-color="#e08058"/><stop offset="100%" stop-color="#ad1e3c"/></linearGradient><path fill="#695094" d="M14 0c7.734 0 14 6.266 14 14 0 7.688-6.234 14-14 14-7.75 0-14-6.297-14-14 0-7.734 6.266-14 14-14zM23.672 21.109c1.453-2 2.328-4.453 2.328-7.109 0-6.609-5.391-12-12-12s-12 5.391-12 12c0 2.656 0.875 5.109 2.328 7.109 0.562-2.797 1.922-5.109 4.781-5.109 1.266 1.234 2.984 2 4.891 2s3.625-0.766 4.891-2c2.859 0 4.219 2.312 4.781 5.109zM20 11c0-3.313-2.688-6-6-6s-6 2.688-6 6 2.688 6 6 6 6-2.688 6-6z"></path></svg>';
        const accountText = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink= "http://www.w3.org/1999/xlink" viewBox="0 0 74 18" width="74"><defs><linearGradient id="MyGradient4"><stop offset="0%"  stop-color="#e08058"/><stop offset="100%" stop-color="#ad1e3c"/></linearGradient></defs><text dx="-1 -1 -1 -1 -1" fill="#695094" text-anchor="middle" alignment-baseline="middle" x="50%" y="50%">${menuTexts.myAccount[config.lang] || menuTexts.myAccount.en}</text></svg>`;        
        const claimIcon = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 245.82 141.73" width="24" height="24"><linearGradient id="MyGradient10"><stop offset="0%"  stop-color="#e08058"/><stop offset="100%" stop-color="#ad1e3c"/></linearGradient><path fill="#695094" d="M175.56 111.37c-22.52 0-40.77-18.84-40.77-42.07S153 27.24 175.56 27.24s40.77 18.84 40.77 42.07-18.25 42.06-40.77 42.06zM26.84 69.31c0-23.23 18.25-42.07 40.77-42.07s40.77 18.84 40.77 42.07-18.26 42.07-40.77 42.07-40.77-18.84-40.77-42.07zM27.27 0C11.54 0 0 12.34 0 28.58v82.32c0 16.24 11.54 30.83 27.27 30.83h72.3c2.17 0 4.19-1.83 5.4-3.7l11.5-20.03a8 8 0 0 1 12.52-.18l11.51 20.34c1.2 1.86 3.22 3.61 5.39 3.61h72.29c15.74 0 27.63-14.6 27.63-30.83V28.58C245.82 12.34 233.93 0 218.19 0H27.27z"/></svg>';
        const claimText = '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink= "http://www.w3.org/1999/xlink" viewBox="0 0 36 18" width="36"><defs><linearGradient id="MyGradient9"><stop offset="0%"  stop-color="#e08058"/><stop offset="100%" stop-color="#ad1e3c"/></linearGradient></defs><text dx="-1 -1 -1 -1 -1" fill="#695094" text-anchor="middle" alignment-baseline="middle" x="50%" y="50%">Claim</text></svg>';        
        // const conatactUsText = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink= "http://www.w3.org/1999/xlink" viewBox="0 0 44 18" width="44"><defs><linearGradient id="MyGradient3"><stop offset="0%"  stop-color="#e08058"/><stop offset="100%" stop-color="#ad1e3c"/></linearGradient></defs><text dx="-1 -1 -1 -1 -1" fill="#695094" text-anchor="middle" alignment-baseline="middle" x="50%" y="50%">${menuTexts.ContactUs[config.lang]}</text></svg>`;            
        return (
            <div>
                {showBottomMenu?
                    <div id="bottom-menu" className='bottom-menu'>
                        <nav>
                            <ul className='list-unstyled bottom-menu-navigate'>
                                <li className='bottom-menu-item'>
                                    <a className='bottom-menu-link' href="/#/category/vod">
                                        <span className="bottom-menu-icon-wrap">
                                            <span className="bottom-menu__icon bottom-menu__icon--home" dangerouslySetInnerHTML={{__html: homeIcon}}/>
                                            <span className="bottom-menu__text bottom-menu__text--home" dangerouslySetInnerHTML={{__html: homeText}}/>
                                        </span>
                                        {/* <span>Home</span> */}
                                    </a>
                                </li>
                                {!isMobio360Plus() && <li className='bottom-menu-item'>
                                    <a className='bottom-menu-link' href="/#/panoramic">
                                        <span className="bottom-menu-icon-wrap">
                                            <span className="bottom-menu__icon bottom-menu__icon--home"><i className="fa fa-image" ria-hidden="true"></i></span>
                                                <span className="bottom-menu__text bottom-menu__text--home" dangerouslySetInnerHTML={{ __html: image360Text }} /> 
                                        </span>
                                        {/* <span>Home</span> */}
                                    </a>
                                </li>}
                                <li className='bottom-menu-item'>
                                    <a className='bottom-menu-link' href="/#/search">
                                        <span className="bottom-menu-icon-wrap">
                                            <span className="bottom-menu__icon bottom-menu__icon--search" dangerouslySetInnerHTML={{__html: searchIcon}}/>
                                            <span className="bottom-menu__text bottom-menu__text--search" dangerouslySetInnerHTML={{__html: searchText}}/>
                                        </span>
                                        {/* <span>Search</span> */}
                                    </a>
                                </li>
                                <li className='bottom-menu-item'>
                                    <a className='bottom-menu-link' href="/#/history">
                                        <span className="bottom-menu-icon-wrap">
                                            {/* <span className="bottom-menu-icon" dangerouslySetInnerHTML={{ __html: historyIcon }} />    */}                     
                                            {/* <img className="bottom-menu-icon__history" src="./img/history.svg" alt="history" /> */}
                                            <span className="bottom-menu__icon bottom-menu__icon--history" dangerouslySetInnerHTML={{__html: historyIcon}}/>                     
                                           <span className="bottom-menu__text bottom-menu__text--history" dangerouslySetInnerHTML={{__html: historyText}}/> 
                                        </span>
                                        {/* <span>History</span> */}
                                    </a>
                                </li>
                                <li className="bottom-menu-item">
                                    <a className='bottom-menu-link' href="/#/account">
                                        <span className="bottom-menu-icon-wrap">
                                            {/* <span className="bottom-menu-icon" dangerouslySetInnerHTML={{ __html: accountIcon }} />     */}                       
                                            {/* <img className="bottom-menu-icon__account" src="./img/account3.svg" alt="My Account" /> */}
                                            <span className="bottom-menu__icon bottom-menu__icon--account" dangerouslySetInnerHTML={{__html: accountIcon}}/>
                                            <span className="bottom-menu__text bottom-menu__text--account" dangerouslySetInnerHTML={{__html: accountText}}/>
                                        </span>
                                        {/* <span>MyAccount</span> */}
                                    </a>
                                </li>
                                {showCuCa(config.domain) && <li className='bottom-menu-item'>
                                    <a className='bottom-menu-link' href={isMobio360Plus() ? `https://mobio360plus.com/customer-care?subdomain=${config.domain}` : `https://mobio360.com/customer-care?subdomain=${config.domain}`}>
                                        <span className="bottom-menu-icon-wrap">
                                            <span className="bottom-menu__icon bottom-menu__icon--home"><i className="fa fa-question" ria-hidden="true"></i></span>
                                                <span className="bottom-menu__text bottom-menu__text--home" dangerouslySetInnerHTML={{ __html: helpText }} /> 
                                        </span>
                                        {/* <span>Home</span> */}
                                    </a>
                                </li>}
                            </ul>
                        </nav>
                    </div>
                    :
                    ""
                }
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        access: state.WelcomeReducer,
        account: state.AccountReducer,
        category: state.CategoryReducer,
        country: state.CountryReducer,
        domain: state.DomainReducer,
        favorite: state.FavoriteReducer,
        flashmessage: state.FlashMessageReducer,
        historyVideos: state.HistoryReducer,
        loader: state.ActivityIndicatorReducer,
        play: state.PlayReducer,
        smartTV: state.SmartTVReducer,
        splash: state.SplashScreenReducer,
        user: state.AuthenticationReducer
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({

    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(BottomMobileMenu);


// WEBPACK FOOTER //
// ./src/components/BottomMobileMenu/BottomMobileMenu.js